// Listen for Shopify section load
document.addEventListener("shopify:section:load", function(event) {
    console.log("{{ section.settings.test_value }}");
});

// Smooth scroll for same-page hash links
document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const targetHash = link.getAttribute("href");
        const target = document.querySelector(targetHash);

        if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: "smooth" });
        }
    });

    // Review Slider
    var ReviewSlide = new Swiper(".Review", {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next.review_next",
            prevEl: ".swiper-button-prev.review_prev",
        },
        breakpoints: {
            320: { slidesPerView: 1, spaceBetween: 20 },
            640: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
        }
    });

    // Video List Slider
    var Videolist = new Swiper(".videoList_slide", {
        slidesPerView: 1.2,
        loop: false,
        spaceBetween: 10,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination.VideoPagi",
            clickable: true,
        },
        breakpoints: {
            640: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
        }
    });

    // Recalculate slider on window resize
    window.addEventListener('resize', function() {
        Videolist.update();
        ReviewSlide.update();
    });
});



document.addEventListener('DOMContentLoaded', initProductGallery);
document.addEventListener('shopify:section:load', initProductGallery);

function initProductGallery(event) {
  const scope = event ? event.target : document;

  const galleryWrappers = scope.querySelectorAll('.product-gallery');

  if (!galleryWrappers.length) return;

  galleryWrappers.forEach((gallery) => {
    
    const thumbsEl = gallery.querySelector('.thumbs-slider');
    const mainEl = gallery.querySelector('.main-slider');
    const nextBtn = gallery.querySelector('.swiper-button-next.media_next');
    const prevBtn = gallery.querySelector('.swiper-button-prev.media_prev');

    if (!thumbsEl || !mainEl) return;

    const thumbSlide = new Swiper(thumbsEl, {
      slidesPerView: 5,
      spaceBetween: 10,
      watchSlidesProgress: true,
      freeMode: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    const mainSlide = new Swiper(mainEl, {
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      thumbs: { swiper: thumbSlide },
    });
  });
}



document.addEventListener('DOMContentLoaded', function() {
  let currentVideo = null;

  document.querySelectorAll('.ctm_video').forEach(container => {
    const video = container.querySelector('video');
    const poster = container.querySelector('.ctm_video_poster');
    const btn = container.querySelector('.ctm_video_btn');

    function showControls() {
      poster.style.opacity = 1;
      btn.style.opacity = 1;
    }

    function hideControls() {
      poster.style.opacity = 0;
      btn.style.opacity = 0;
    }

    function playVideo() {
      // Stop other video if playing
      if (currentVideo && currentVideo !== video) {
        currentVideo.pause();
        const parent = currentVideo.closest('.ctm_video');
        parent.querySelector('.ctm_video_poster').style.opacity = 1;
        parent.querySelector('.ctm_video_btn').style.opacity = 1;
      }
      video.play();
      hideControls();
      currentVideo = video;
    }

    function pauseVideo() {
      video.pause();
      showControls();
      if (currentVideo === video) currentVideo = null;
    }

    function toggleVideo() {
      if (video.paused) {
        playVideo();
      } else {
        pauseVideo();
      }
    }

    // Play/pause on button or video click
    btn.addEventListener('click', toggleVideo);
    video.addEventListener('click', toggleVideo);
    
    // Stop video when it ends
    video.addEventListener('ended', pauseVideo);

    // Stop video if click outside video container
    document.addEventListener('click', function(e) {
      if (currentVideo && !container.contains(e.target)) {
        pauseVideo();
      }
    });
  });
});